import { render, staticRenderFns } from "./dynamic-item.vue?vue&type=template&id=7f427f9a&scoped=true&"
import script from "./dynamic-item.vue?vue&type=script&lang=js&"
export * from "./dynamic-item.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-item.vue?vue&type=style&index=0&id=7f427f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f427f9a",
  null
  
)

export default component.exports